export default "__VITE_ASSET__CrvkH8ri__"